angular.module("vgresiduos").directive("disposalResiduesDocuments", function () {
	return {
		scope: true,
		controller: "DisposalResiduesDocumentsCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalResiduesDocuments/disposalResiduesDocuments_template.html"
	};
});
